import { atom } from 'jotai'
import { EditBeneficiarySheet } from 'types/atoms/atom.editBeneficiary'

export const beneficiaryToUpdateAtom = atom<EditBeneficiarySheet>({} as EditBeneficiarySheet)
beneficiaryToUpdateAtom.debugLabel = 'edit-beneficiary'
